import { ArmyListUnit } from '@Models';
import { ArmyListUnitExportView } from '@Selectors/builder/myArmyList/export/view/export';
import { exportArmyListUnit } from '@Selectors/builder/myArmyList/export/exportArmyListUnit';
import { AppState } from '@Redux/store';

export const exportToClipboard = (
  state: AppState,
  name: string,
  army: string,
  units: Array<ArmyListUnit>,
  points: string,
  showDetails: boolean = false,
): string => {
  const unitNames = units
    .map(
      (unit) =>
        exportArmyListUnit(state, {
          armyListUnit: unit,
          showDetails: showDetails,
        }) ?? '',
    )
    .filter((value) => value.length !== 0)
    .map((item) => item.replace(new RegExp(/<[/]*strong>/gi), ''));

  return formatCopy(name, army, unitNames, points);
};

export const exportToClipboardWithOrganisation = (
  state: AppState,
  name: string,
  army: string,
  units: Array<ArmyListUnitExportView>,
  points: string,
): string => {
  const unitNames = units
    .flatMap((unit) =>
      [
        `++ ${unit.name} ++`,
        unit.armyListUnits.map((armyListUnit: ArmyListUnit) =>
          exportArmyListUnit(state, { armyListUnit: armyListUnit }),
        ),
      ].flat(),
    )
    .filter(
      (value) => value !== null && value !== undefined && value.length !== 0,
    )
    .map((item) => item.replace(new RegExp(/<[/]*strong>/gi), ''));

  return formatCopy(name, army, unitNames, points);
};

const formatCopy = (
  name: string,
  army: string,
  unitNames: Array<string>,
  points: string,
): string => {
  return [name, army, ...unitNames, points]
    .filter(
      (value) => value !== null && value !== undefined && value.length !== 0,
    )
    .join('\n');
};
